import { styled, SxProps, Theme } from "@mui/material"
import { classes } from "@tm/utils"
import { simpleWidgetCardClasses, simpleWidgetCardName, simpleWidgetCardSlots } from "@tm/themes"
import { SimpleCardCard } from "../../../muiStyled/Surfaces/simpleCard"
import { Icon } from "../../../muiStyled/DataDisplay/Icons"
import { Typography } from "../../../muiStyled/DataDisplay/typographie"

export const SimpleWidgetCardCover = styled(WidgetCoverComponent, {
    name: simpleWidgetCardName,
    slot: simpleWidgetCardSlots.cover,
    overridesResolver: (_, styles) => styles.cover,
})(({ theme }) => ({
    boxShadow: "rgba(0, 0, 0, 0.13) 0px 1px 5px 0px",
    "&:hover": {
        borderColor: theme.palette.primary.main,
    },
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.radius?.default || "3px",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    height: "100%",
    width: "100%",
    cursor: "pointer",
}))

type WidgetCoverProps = {
    title?: React.ReactNode
    icon?: string
    sx?: SxProps<Theme>
    className?: string
    onCoverClick?: () => void
}

function WidgetCoverComponent(props: WidgetCoverProps) {
    const { title, icon, sx, onCoverClick } = props
    return (
        <SimpleCardCard
            className={classes(simpleWidgetCardClasses.cover, props.className)}
            sx={{ ...sx }}
            onClick={onCoverClick}
            data-testid="widget-cover"
        >
            <Icon name={icon} size="extralarge" />
            <Typography variant="body2">{title}</Typography>
        </SimpleCardCard>
    )
}
